import { Box, Flex, Spacing, Text } from '@approvalmax/ui/src/components';
import { memo, useRef } from 'react';
import { useHoverDirty } from 'react-use';
import { getPath, Path } from 'urlBuilder';

import { usePreviewText } from './ReportCard.hooks';
import { messages } from './ReportCard.messages';
import { BoxLink } from './ReportCard.styles';
import { ReportCardProps } from './ReportCard.types';

export const ReportsListCard = memo<ReportCardProps>((props) => {
    const { company, report, onClick } = props;

    const hoveredRef = useRef(null);

    const isHovered = useHoverDirty(hoveredRef);
    const filtersPreviewText = usePreviewText(report);

    const path = getPath(Path.report, report.id, company.id, report.reportType);

    return (
        <BoxLink to={path} onClick={onClick} data-qa='report-card' ref={hoveredRef}>
            <Box
                bordered
                height='100%'
                radius='xsmall'
                spacing='24 32'
                borderColor={isHovered ? 'blue100' : 'midnight50'}
            >
                <Text
                    data-qa='report-card-name'
                    font='headline'
                    fontSize='xsmall'
                    fontWeight='regular'
                    color={isHovered ? 'blue100' : 'midnight80'}
                >
                    {report.name.substring(0, 125) || messages.unnamedReport}
                </Text>

                <Spacing height={16} />

                <Flex direction='column' spacing='0' wrap={false}>
                    {filtersPreviewText.map((text) => (
                        <Text
                            data-qa='report-card-filter'
                            font='body'
                            fontSize='medium'
                            fontWeight='regular'
                            color={isHovered ? 'blue100' : 'midnight70'}
                            wrap={true}
                            ellipsis={2}
                            key={text}
                        >
                            {text}
                        </Text>
                    ))}
                </Flex>
            </Box>
        </BoxLink>
    );
});

ReportsListCard.displayName = 'ReportsListCard';
